import { useState, forwardRef } from 'react'
import { useFocusWithin } from '@react-aria/interactions'
import Styles from './MessageField.module.scss'
import cx from 'classnames'
import { ProseInput } from 'common/ProseInput/ProseInput'
import { ProseState } from 'common/ProseInput/ProseState'
import { ProseStateProvider } from 'common/ProseInput/ProseStateContext'
import { Toolbar } from 'common/ProseInput/components/Toolbar'
import { MessageFieldProps } from './Types'
import { ProseInputHandle } from 'common/ProseInput/Types'

export const MessageField = forwardRef<ProseInputHandle, MessageFieldProps>(
  ({ value = '', onChange, placeholder, isDisabled }, forwardedRef) => {
    const [proseState] = useState(() => new ProseState())
    const [isFocusWithin, setFocusWithin] = useState(false)
    const { focusWithinProps } = useFocusWithin({
      onFocusWithinChange: (isFocusWithin) => setFocusWithin(isFocusWithin),
    })

    return (
      <div className={cx(Styles.proseInputContainer, { [Styles.focused]: isFocusWithin })} {...focusWithinProps}>
        <ProseStateProvider state={proseState}>
          <Toolbar.Root className={Styles.toolbar}>
            <Toolbar.Bold />
            <Toolbar.Italic />
            <Toolbar.Underline />
            <Toolbar.InlineCode />
            <Toolbar.BulletList />
            <Toolbar.OrderedList />
            <Toolbar.Mention />
            <Toolbar.Emoji />
          </Toolbar.Root>
          <ProseInput
            isDisabled={isDisabled}
            placeholder={placeholder}
            initialHtmlString={value}
            onChange={onChange}
            className={Styles.proseInput}
            ref={forwardedRef}
          />
        </ProseStateProvider>
      </div>
    )
  },
)
